module.exports = __webpack_public_path__ + "img/paiement.1d2983ce.svg";